export default __webpack_public_path__ + "static/media/cnrc-logo.391b5cbd.png";